module.exports = __webpack_public_path__ + "media/styles/images/png/audio_placeholder-1181a42e959d671203b339fc60548614.png";